import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { HeaderService } from '../services/header.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessagePopupService } from '../services/message-popup.service';
import { ThemeSetting } from '../objects/ThemeObject';
import { ThemeSettingService } from '../services/theme-setting.service';

@Component({
  selector: 'app-onetimeaction',
  templateUrl: './onetimeaction.component.html',
  styleUrls: ['./onetimeaction.component.css']
})
export class OnetimeactionComponent implements OnInit {

  @ViewChild('customLoadingTemplate') customLoadingTemplate: TemplateRef<any>;
  isBusy:boolean = true;
  loaderConfig:any;

  constructor(private router:Router, private route:ActivatedRoute, private headerService:HeaderService, private messagePopupService: MessagePopupService, private themeSettingService: ThemeSettingService) { }

  ngOnInit() {
    var themes:ThemeSetting = this.themeSettingService.getTheme();
    this.loaderConfig = themes;
    var oneTimeKey = this.route.snapshot.paramMap.get('oneTimeKey');
    var userId = this.route.snapshot.paramMap.get('userId');
    this.headerService.performOneTimeAction(userId,oneTimeKey).subscribe(result=>{
      this.router.navigate(["/"]);
      this.isBusy = false;
      if (result){
        this.handleWorkflowReturn(result);
      }
      else{
        this.messagePopupService.popMessage("Error", "One time key is not valid.", ["OK"]).subscribe((respond) => {
        });
      }
    });
  }

  handleWorkflowReturn(result: any): any {
    var command = JSON.parse(result);
      switch(command.ReturnType){
        case 0:
          if(command.Arguments){
            var path = [];
            command.Arguments.forEach(element => {
              path.push(element);
            });
            this.router.navigate(path);
          }
          break;
        case 1:
          this.messagePopupService.popMessage(command.Arguments[0], command.Arguments[1], ["OK"]).subscribe((respond) => {
          
          });
          break;
        case 8:
          this.messagePopupService.popMessage(command.Arguments[0], command.Arguments[1], ["OK"]).subscribe((respond) => {
            if (respond.answer == "OK"){
              var path = [];
              command.Arguments.forEach(argument => {
                path.push(argument);
              });
              if (path.length > 2){
                var newPath = path.slice(2);
                this.router.navigate(newPath);
              }
            }
          });
          break;
      }
      
  }
}
